// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3gaX0","header":"Messages_header__1I0KX"};